import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Helpdesk({permission, subscriptors_manager, activeItem}) {
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  const hasHelpdesk = permission && permission !== '0';
  const hasSubscribers = subscriptors_manager && String(subscriptors_manager) !== '0';

  return (
    <Accordion.Item eventKey="5">
      <Accordion.Header>
        <span role="img" aria-label="projects">🐸</span> HelpDesk {permission === '1' && ('👑')}
      </Accordion.Header>
      <Accordion.Body className="p-0">
        <Nav className="flex-column">
          {hasHelpdesk && (
            <Nav.Link
              active={activeItem === 'helpdesk'}
              style={activeItem === 'helpdesk' ? activeStyles : undefined}
              onClick={() => navigate('/helpdesk')}
            >
              Helpdesk
            </Nav.Link>
          )}
          {hasHelpdesk && (
            <Nav.Link
              active={activeItem === 'helpdesk_report'}
              style={activeItem === 'helpdesk_report' ? activeStyles : undefined}
              onClick={() => navigate('/helpdesk_report')}
            >
              Helpdesk Report
            </Nav.Link>
          )}
          {hasSubscribers && (
            <Nav.Link
              active={activeItem === 'suscripciones_t8'}
              style={activeItem === 'suscripciones_t8' ? activeStyles : undefined}
              onClick={() => navigate('/helpdesk/suscripciones-t8')}
            >
              Suscripciones de T8
            </Nav.Link>
          )}
        </Nav>
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default Helpdesk;
